import type React from 'react'
import { type Control, Controller } from 'react-hook-form'
import { Card } from '../../components/skeleton/Card'

interface PlanRadioCardProps {
  control?: Control<any>
  name: string
  value: string
  title: string
  price: string
  description: string
}

export const PlanRadioCard: React.FC<PlanRadioCardProps> = ({
  control,
  name,
  value,
  title,
  price,
  description,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: 'Please select a plan' }}
      render={({ field }) => (
        <Card
          className={`cursor-pointer p-4 transition-all ${
            field.value === value
              ? 'bg-primary/10 dark:bg-slate-700 border-primary'
              : 'bg-background dark:bg-slate-800 hover:bg-primary/5 dark:hover:bg-slate-700/50'
          }`}
          onClick={() => field.onChange(value)}>
          <input
            type="radio"
            {...field}
            value={value}
            checked={field.value === value}
            className="sr-only"
            id={`plan-${value}`}
          />
          <label htmlFor={`plan-${value}`} className="cursor-pointer">
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-lg font-semibold dark:text-slate-100">{title}</h3>
              <span className="text-xl font-bold dark:text-slate-100">{price}</span>
            </div>
            <p className="text-sm text-muted-foreground dark:text-slate-300">
              {description}
            </p>
            <p className="text-sm text-muted-foreground dark:text-slate-400 italic pt-1">
              Cancellable anytime
            </p>
          </label>
        </Card>
      )}
    />
  )
}
